/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfficeDto } from '../../models/office-dto';

export interface OfficeControllerUpdate$Params {
      body: OfficeDto
}

export function officeControllerUpdate(http: HttpClient, rootUrl: string, params: OfficeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<OfficeDto>> {
  const rb = new RequestBuilder(rootUrl, officeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfficeDto>;
    })
  );
}

officeControllerUpdate.PATH = '/api/office';
